export default "<button class=\"player__panel-button j-fullscreen\" title=\"Fullscreen\">\n  <span class=\"icon-container\"></span>\n</button>\n"